// 📁 src/admin/CustomerInfoPage.jsx

import React, { useEffect, useState } from 'react';

export default function CustomerInfoPage() {
  const [accountRegistry, setAccountRegistry] = useState({});
  const [registrationMode, setRegistrationMode] = useState(
    localStorage.getItem('registrationMode') || 'public'
  );

  useEffect(() => {
    const registry = JSON.parse(localStorage.getItem('accountRegistry') || '{}');
    setAccountRegistry(registry);
  }, []);

  useEffect(() => {
    localStorage.setItem('registrationMode', registrationMode);
  }, [registrationMode]);

  const accounts = Object.values(accountRegistry);

  return (
    <div className="p-6 relative">
      {/* 🔹 Header with toggle on top-right */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">👥 Customer Info</h2>
        <div className="flex items-center space-x-2">
          <label className="font-semibold text-gray-700">Registration Mode:</label>
          <select
            value={registrationMode}
            onChange={(e) => setRegistrationMode(e.target.value)}
            className="border rounded px-2 py-1 text-sm"
          >
            <option value="public">🌐 Public</option>
            <option value="private">🔒 Private</option>
          </select>
        </div>
      </div>

      <p className="text-gray-600 mb-6">
        This module displays tenant-aware customer details for audit and support.
      </p>

      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-100 text-sm text-gray-700">
            <th className="border px-3 py-2 text-left">Company</th>
            <th className="border px-3 py-2 text-left">Tenant ID</th>
            <th className="border px-3 py-2 text-left">Email</th>
            <th className="border px-3 py-2 text-left">Phone</th>
            <th className="border px-3 py-2 text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          {accounts.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center py-4 text-gray-500 italic">
                No customer records found.
              </td>
            </tr>
          ) : (
            accounts.map((acc, index) => (
              <tr key={index} className="text-sm text-gray-800">
                <td className="border px-3 py-2">{acc.companyName}</td>
                <td className="border px-3 py-2">{acc.tenantId}</td>
                <td className="border px-3 py-2">{acc.email}</td>
                <td className="border px-3 py-2">{acc.phone || '—'}</td>
                <td className="border px-3 py-2">{acc.status || 'pending'}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
